module.exports = __webpack_public_path__ + "img/125.c2332368.jpg";